import { Image, Text, View } from '@react-pdf/renderer';

import styles from './HomepageStyles.ts';

interface HomepageData {
  reportTitle: string;
  date: string;
  description: string;
  imagePath: string;
}

interface HomepageProps {
  homepageData: HomepageData;
}

const Homepage = ({ homepageData }: HomepageProps) => (
  <View style={styles.container}>
    <View style={styles.header}>
      <Text style={styles.reportTitle}>{homepageData.reportTitle}</Text>
      <View style={styles.rightSection}>
        <Text>{homepageData.date}</Text>
        <Text>Date</Text>
      </View>
    </View>

    <View style={styles.description}>
      <Image style={styles.descriptionImage} src={homepageData.imagePath} />
      <View style={styles.descriptionText}>
        <Text style={styles.descriptionTruncate}>{homepageData.description}</Text>
      </View>
    </View>
  </View>
);

export default Homepage;
